import { materials } from '../../data/homepageData';
import { ResponsiveImage } from '../ui/ResponsiveImage';

export function MaterialsEcosystem() {
  return (
    <section id="materials" className="section materials-section">
      <h2>Prémiové materiály &amp; ecosystem</h2>
      <div className="materials-grid">
        {materials.map((item) => (
          <article className="material-card" key={item.title}>
            <ResponsiveImage srcBase={item.image} alt={item.title} className="material-card__image" sizes="(max-width: 768px) 88vw, 260px" />
            <div className="material-card__overlay">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
